import { FC } from 'react';
import { cn } from '@/shared/lib';
import { useAppSelector } from '@/app/store';
import { useTranslation } from 'react-i18next';
import { InformationNote, Typography } from '@/shared/components';

interface DemoModeNoteProps {
  className?: string;
  variant?: 'default' | 'alert';
}

export const DemoModeNote: FC<DemoModeNoteProps> = ({ className, variant = 'default' }) => {
  const { t } = useTranslation();
  const { hasLegalInfo, acceptedOwnerDocuments, hasActiveSubscription } = useAppSelector(
    (state) => state.application.demoMode,
  );

  if (acceptedOwnerDocuments && hasLegalInfo && hasActiveSubscription) return null;

  const title = !acceptedOwnerDocuments
    ? t('info.demoMode')
    : !hasLegalInfo
      ? t('info.adminsPreparing')
      : t('info.notAcceptOrders');

  if (variant === 'alert')
    return (
      <div
        className={cn(
          'flex flex-col items-center justify-center gap-1 bg-badge-background03 px-3.5 py-2 text-center text-[#3472bf]',
          className,
        )}
      >
        <Typography variant='text5' color='badgeStroke03'>
          {title}
        </Typography>
      </div>
    );

  return <InformationNote title={title} className={className} />;
};
